// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__4DWx4","modal":"Modal_modal__fb72-"};